/*
 * Home — placeholder. This will become the full ported HomeScreen from mobile
 * (recent rounds, active group, quick-actions row, etc.) over the next few
 * sessions. For now it just proves the auth round-trip is working and gives
 * us a logout button.
 */

import { Link, useNavigate } from 'react-router-dom';
import { Flag, Trophy } from 'lucide-react';

import { useAuthStore } from '@/store/authStore';
import { api } from '@/lib/api';
import { BrandWordmark } from '@/components/BrandWordmark';

export default function Home() {
  const navigate = useNavigate();
  const { displayName, username, logout: clientLogout } = useAuthStore();

  async function handleLogout() {
    const refresh = useAuthStore.getState().refreshToken;
    if (refresh) {
      // Best-effort: tell the API to revoke. If it fails we still clear locally.
      api.logout(refresh).catch(() => {});
    }
    clientLogout();
    navigate('/app/login', { replace: true });
  }

  return (
    <div className="app-shell">
      <header className="app-topbar">
        <div className="app-topbar-inner">
          {/* Brand link stays inside the SPA. The earlier <a href="/">
              did a full reload to the marketing site, which made it
              look like the user was signed out (the marketing route is
              public and always renders Sign in / Try the web app). */}
          <Link to="/app/home" className="app-brand">
            <BrandWordmark className="brand-wordmark" />
          </Link>
          <button onClick={handleLogout} className="app-topbar-action">
            Sign out
          </button>
        </div>
      </header>

      <main className="app-main">
        <section className="app-hero">
          <p className="app-eyebrow">Welcome back</p>
          <h1 className="app-h1">{displayName ?? username ?? 'Golfer'}</h1>
          <p className="app-lede">
            Jump into your events, or set up the next one.
          </p>
        </section>

        {/* Future web features (rounds history, groups, solo scoring,
            standalone leaderboards) are tracked in BACKLOG.md — the
            "coming soon" placeholder cards read as clutter once real
            features shipped around them. */}
        <section className="app-grid">
          <Link to="/app/tournaments" className="t-section-card" style={{ borderColor: 'rgba(212,175,55,0.45)' }}>
            <span className="t-section-card-icon"><Trophy /></span>
            <span className="t-section-card-body">
              <h3 className="t-section-card-title">Team Cup events</h3>
              <p className="t-section-card-sub">Set up team match-play tournaments, build rounds &amp; pairings, run a captain's draft, and project the leaderboard on game day.</p>
            </span>
          </Link>
          <Link to="/app/scorecards/new" className="t-section-card">
            <span className="t-section-card-icon t-row-icon-green"><Flag /></span>
            <span className="t-section-card-body">
              <h3 className="t-section-card-title">Start a scorecard</h3>
              <p className="t-section-card-sub">Set up a casual round, choose Stableford points, and keep score hole by hole.</p>
            </span>
          </Link>
        </section>
      </main>
    </div>
  );
}
